import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Contactform } from "./components/Contactform";
import Aboutus from "./images/advantages.webp";
import { Accordion, AccordionItem } from "react-light-accordion";
import Ericssion from "./images/ericsson.webp";
import alphion from "./images/alphion.png";
import Nokia from "./images/nokia.webp";
import Huawai from "./images/huawei.webp";
import Genexis from "./images/genexis.webp";
import Zte from "./images/zte.webp";
import Cisco from "./images/cisco.webp";
import Sterlite from "./images/sterlite.webp";
import Oracle from "./images/oracle.webp";
import Solarwinds from "./images/solarwinds.webp";
import Elite from "./images/elitecore.webp";
import H8 from "./images/h8-logo.png";
import { Link } from "react-router-dom";
import BannerDesktop from "./images/BannerBooknow.jpeg";

import BannerMobile from "./images/Banner01m.jpg";

export const Enterprise2 = () => {
  const ENTERPRISE_CATEGORY_ID = "19";

  // Real plans under category 19, from the `plans` table
  const ENTERPRISE_PLANS = [
    { id: "138", name: "ILL" },
    { id: "139", name: "P2P" },
    { id: "140", name: "MPLS" },
    { id: "141", name: "NLD" },
  ];

  const [state, setState] = useState({
    turnover: 1,
    workforce: 1,
    states: 1,
    cities: 1,
  });

  // =========================================================
  // ENTERPRISE FORM STATES
  // =========================================================

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("");

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  // Searchable city dropdown
  const [citySearch, setCitySearch] = useState("");
  const [cityDropdownOpen, setCityDropdownOpen] = useState(false);

  const cityDropdownRef = useRef(null);

  const [user_name, setusername] = useState("");
  const [user_mobile, setusermobile] = useState("");

  const [isDisabled, setIsDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // =========================================================
  // FORM REFS
  // =========================================================

  const ref_category = useRef(null);
  const ref_plan = useRef(null);
  const ref_name = useRef(null);
  const ref_mobile = useRef(null);
  const ref_state = useRef(null);
  const ref_city = useRef(null);

  // =========================================================
  // GET STATES
  // =========================================================

  useEffect(() => {
    axios
      .get(window.weburl + "api/get_states.php")
      .then((response) => {
        setStates(response.data || []);
      })
      .catch((error) => {
        console.log("State Error:", error);
      });
  }, []);

  // =========================================================
  // GET CITIES
  // =========================================================

  const getCities = (stateId) => {
    if (!stateId) {
      setCities([]);
      setSelectedCity("");
      setCitySearch("");
      setCityDropdownOpen(false);
      return;
    }

    axios
      .get(window.weburl + "api/get_cities.php?sid=" + stateId)
      .then((response) => {
        setCities(response.data || []);

        // Reset city when state changes
        setSelectedCity("");
        setCitySearch("");
        setCityDropdownOpen(false);
      })
      .catch((error) => {
        console.log("City Error:", error);
        setCities([]);
        setSelectedCity("");
      });
  };

  // =========================================================
  // SEARCHABLE CITY DROPDOWN
  // =========================================================

  const filteredCities = cities.filter((city) =>
    String(city.cityname || "")
      .toLowerCase()
      .includes(citySearch.toLowerCase()),
  );

  // Close city dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        cityDropdownRef.current &&
        !cityDropdownRef.current.contains(event.target)
      ) {
        setCityDropdownOpen(false);
        setCitySearch("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // =========================================================
  // CATEGORY CHANGE
  // =========================================================

  const handleCategoryChange = (event) => {
    const category = event.target.value;

    setSelectedCategory(category);

    // Reset plan whenever category changes — user must pick one of the
    // real plans (ILL / P2P / MPLS / NLD) from the Plan dropdown.
    setSelectedPlan("");
  };

  // =========================================================
  // STATE CHANGE
  // =========================================================
  const handleStateChange = (event) => {
    const stateValue = event.target.value;

    setSelectedState(stateValue);
    setSelectedCity("");
    setCitySearch("");
    setCityDropdownOpen(false);

    getCities(stateValue);
  };

  // =========================================================
  // PHONE VALIDATION
  // =========================================================

  const isValidPhone = (phone) => {
    const regex = /^[6-9][0-9]{9}$/;
    return regex.test(phone);
  };

  // =========================================================
  // ENABLE / DISABLE SUBMIT
  // =========================================================

  const handledisable = () => {
    if (isValidPhone(user_mobile)) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  // =========================================================
  // FORM VALIDATION
  // =========================================================

  const validateForm = () => {
    if (!selectedCategory) {
      alert("Please select Category");

      if (ref_category.current) {
        ref_category.current.focus();
      }

      return false;
    }

    if (!selectedPlan) {
      alert("Please select Plan");

      if (ref_plan.current) {
        ref_plan.current.focus();
      }

      return false;
    }

    if (!isValidPhone(user_mobile)) {
      alert("Please enter valid Mobile number");

      if (ref_mobile.current) {
        ref_mobile.current.focus();
      }

      return false;
    }

    if (!selectedState) {
      alert("Please select State");

      if (ref_state.current) {
        ref_state.current.focus();
      }

      return false;
    }

    if (!selectedCity) {
      alert("Please select City");

      if (ref_city.current) {
        ref_city.current.focus();
      }

      return false;
    }

    return true;
  };

  // =========================================================
  // SUBMIT ENTERPRISE FORM
  // =========================================================

  const handleSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }

    if (isSubmitting) {
      return false;
    }

    // =====================================================
    // VALIDATION
    // =====================================================

    if (!validateForm()) {
      return false;
    }

    setIsSubmitting(true);

    // =====================================================
    // BUTTON
    // =====================================================

    const buttonText = document.getElementById("enterprise_submit_button_text");

    if (buttonText) {
      buttonText.innerText = "SUBMITTING...";
    }

    // =====================================================
    // FORM DATA
    // =====================================================

    const fData = new FormData();

    // Booking type
    fData.append("td_name", "bookings");

    // =====================================================
    // ENTERPRISE VALUES (from dropdowns)
    // =====================================================

    fData.append("catID", selectedCategory);
    fData.append("planID", selectedPlan);

    // =====================================================
    // USER DETAILS
    // =====================================================

    fData.append("user_name", user_name);
    fData.append("user_mobile", user_mobile);
    fData.append("user_state", selectedState);
    fData.append("user_city", selectedCity);

    // Current page URL
    fData.append("utm_url", window.location.href);

    // Google Ads reference
    fData.append("ref", "GADS_ENTERPRISE");

    // =====================================================
    // API
    // =====================================================

    const apiURL = window.weburl + "api/insert_hook.php";

    // =====================================================
    // SUBMIT
    // =====================================================

    axios.post(apiURL, fData).then((response) => {
      console.log("ENTERPRISE BOOKING RESPONSE:", response.data);

      const responseText = response.data ? response.data.toString() : "";

      // =================================================
      // SUCCESS
      // =================================================
      if (responseText.indexOf("Thank you!") !== -1) {
        // Google Ads conversion
        if (window.gtag) {
          window.gtag("event", "conversion", {
            send_to: "AW-801924308/HeMjCImtpfIbENTJsf4C",
          });
        }

        // Meta Pixel
        if (window.fbq) {
          window.fbq("track", "Lead");
        }
        // Save the Enterprise2 page to return to after the Thank You page
        sessionStorage.setItem("thankYouReturnUrl", "/enterprise2");

        // Redirect to thank-you page.
        // The short delay gives the tracking calls time to fire.
        // isSubmitting stays true, so the button can't be clicked again.
        setTimeout(() => {
          window.location.href = "/thank-you";
        }, 500);

        return;
      }

      // =================================================
      // FAILURE (show actual PHP response)
      // =================================================
      alert(responseText || "Something went wrong.");

      setIsSubmitting(false);
      setIsDisabled(true);

      if (buttonText) {
        buttonText.innerText = "Submit";
      }
    });

    return false;
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <>
      <Header />

      {/* =================================================
                    BANNER SPACER
                    (keeps header spacing consistent, no image)
          ================================================= */}

      <section id="banner" className="p-0">
        <div className="banner booknow filter m-0 h-120"></div>
      </section>

      {/* =================================================
                    ENTERPRISE BOOKING FORM
                    (moved above other content, banner image removed)
          ================================================= */}

      <section id="login" className="p-0">
        <div className="booknow filter m-0">
          <div className="container">
            <div className="row">
              <div className="web-container">
                {/* =================================
                                    TITLE
                                ================================== */}

                <div className="title m-0">
                  <span>Book Now</span>
                </div>

                {/* =================================
                                    HEADING
                                ================================== */}

                <div className="heading">
                  <h4>Book Enterprise Plan</h4>
                </div>

                <div className="booknow-layout">
                  {/* CAROUSEL: replaces video, left on desktop, top on mobile */}
                  <div className="booknow-video booknow-carousel">
                    <picture>
                      <source
                        media="(max-width: 767px)"
                        srcSet={BannerMobile}
                      />
                      <img
                        src={BannerDesktop}
                        alt="Book now"
                        className="carousel-slide active"
                      />
                    </picture>
                  </div>

                  {/* =================================
                                    FORM
                                ================================== */}

                  <div className="footerform bookingform">
                    <div className="form">
                      <form onSubmit={handleSubmit}>
                        <ul>
                          {/* =================================
                                                    CATEGORY
                                                ================================== */}

                          <li>
                            <select
                              name="selectedCategory"
                              id="enterprise_selectedCategory"
                              value={selectedCategory}
                              onChange={handleCategoryChange}
                              ref={ref_category}
                            >
                              <option value="">Select Category</option>
                              <option value={ENTERPRISE_CATEGORY_ID}>
                                Enterprise
                              </option>
                            </select>
                          </li>

                          {/* =================================
                                                    PLAN
                                                ================================== */}

                          <li>
                            <select
                              name="selectedPlan"
                              id="enterprise_selectedPlan"
                              value={selectedPlan}
                              onChange={(event) => {
                                setSelectedPlan(event.target.value);
                              }}
                              ref={ref_plan}
                            >
                              <option value="">Select Plan</option>

                              {selectedCategory === ENTERPRISE_CATEGORY_ID &&
                                ENTERPRISE_PLANS.map((plan) => (
                                  <option key={plan.id} value={plan.id}>
                                    {plan.name}
                                  </option>
                                ))}
                            </select>
                          </li>

                          {/* =================================
                                                    NAME
                                                ================================== */}

                          <li>
                            <input
                              type="text"
                              name="user_name"
                              id="enterprise_user_name"
                              placeholder="Your name"
                              value={user_name}
                              onChange={(e) => {
                                setusername(e.target.value);
                              }}
                              onBlur={handledisable}
                              ref={ref_name}
                            />
                          </li>

                          {/* =================================
                                                    MOBILE
                                                ================================== */}

                          <li>
                            <input
                              type="text"
                              name="user_mobile"
                              id="enterprise_user_mobile"
                              placeholder="Mobile number*"
                              maxLength="10"
                              value={user_mobile}
                              onChange={(e) => {
                                const value = e.target.value.replace(
                                  /[^0-9]/g,
                                  "",
                                );

                                setusermobile(value);
                              }}
                              onBlur={handledisable}
                              ref={ref_mobile}
                            />
                          </li>

                          {/* =================================
                                                    STATE
                                                ================================== */}

                          <li>
                            <select
                              name="selectedState"
                              id="enterprise_selectedState"
                              value={selectedState}
                              onChange={handleStateChange}
                              ref={ref_state}
                            >
                              <option value="">Select State*</option>

                              {states.map((stateItem, index) => (
                                <option
                                  key={
                                    stateItem.sno || stateItem.stateid || index
                                  }
                                  value={stateItem.sno || stateItem.stateid}
                                >
                                  {stateItem.state ||
                                    stateItem.sname ||
                                    stateItem.name}
                                </option>
                              ))}
                            </select>
                          </li>

                          {/* =================================
                                                    CITY
                                                ================================== */}

                          <li>
                            <div
                              className="city-dropdown"
                              ref={cityDropdownRef}
                            >
                              {/* MAIN CITY FIELD */}

                              <input
                                type="text"
                                name="selectedCity"
                                id="enterprise_selectedCity"
                                value={
                                  cityDropdownOpen
                                    ? citySearch
                                    : cities.find(
                                        (city) =>
                                          String(city.cityid) ===
                                          String(selectedCity),
                                      )?.cityname || ""
                                }
                                placeholder="Select City*"
                                autoComplete="off"
                                disabled={!selectedState}
                                readOnly={!cityDropdownOpen}
                                ref={ref_city}
                                onFocus={() => {
                                  if (!selectedState) return;

                                  setCityDropdownOpen(true);
                                  setCitySearch("");
                                }}
                                onClick={() => {
                                  if (!selectedState) return;

                                  setCityDropdownOpen(true);
                                  setCitySearch("");
                                }}
                                onChange={(e) => {
                                  setCitySearch(e.target.value);
                                  setCityDropdownOpen(true);
                                }}
                              />

                              {/* ARROW */}

                              <span
                                className={`city-dropdown-arrow ${
                                  cityDropdownOpen ? "open" : ""
                                }`}
                                onClick={() => {
                                  if (!selectedState) return;

                                  setCityDropdownOpen((prev) => !prev);

                                  if (!cityDropdownOpen) {
                                    setCitySearch("");
                                  }
                                }}
                              >
                                ˅
                              </span>

                              {/* DROPDOWN */}

                              {cityDropdownOpen && selectedState && (
                                <div className="city-options">
                                  {/* SEARCH */}

                                  <div className="city-search-box">
                                    <input
                                      type="text"
                                      placeholder="Search city..."
                                      value={citySearch}
                                      onChange={(e) =>
                                        setCitySearch(e.target.value)
                                      }
                                      autoFocus
                                    />
                                  </div>

                                  {/* CITY LIST */}

                                  <div className="city-list">
                                    {filteredCities.length > 0 ? (
                                      filteredCities.map((city) => (
                                        <div
                                          key={city.cityid}
                                          className="city-option"
                                          onClick={() => {
                                            setSelectedCity(city.cityid);
                                            setCitySearch("");
                                            setCityDropdownOpen(false);
                                          }}
                                        >
                                          {city.cityname}
                                        </div>
                                      ))
                                    ) : (
                                      <div className="no-city">
                                        No city found
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </li>

                          {/* =================================
                                                    SUBMIT
                                                ================================== */}

                          <li className="buttnprop">
                            <input
                              type="submit"
                              value=""
                              id="enterprise_submit_button"
                              disabled={isDisabled || isSubmitting}
                            />

                            <span
                              id="enterprise_submit_button_text"
                              className={isDisabled ? "disabled" : ""}
                              onClick={(e) => {
                                if (!isDisabled && !isSubmitting) {
                                  handleSubmit(e);
                                }
                              }}
                            >
                              {isSubmitting ? "SUBMITTING..." : "Submit"}
                            </span>
                          </li>
                        </ul>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =================================================
                    ENTERPRISE
          ================================================= */}

      <section id="enterprise">
        <div className="enterprise">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="title"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <span>Enterprise</span>

                  <h3>Why businesses run better on Netplus?</h3>
                </div>

                <div
                  className="smartcont"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <p>
                    Netplus Internet Leased Line offers dedicated, high-speed
                    connectivity to meet your growing business needs. Shared
                    internet lines along with multiple users accessing the
                    network simultaneously, can lead to drop in efficiency.
                    Netplus Internet Fiber leased line empowers you with
                    dedicated bandwidth ensuring reliable high-speed
                    communication and helps your team's growing need of
                    cloud-based work. These internet leased line plans can be
                    personalized to your requirements.{" "}
                    <Link to="/contact-us">Contact us</Link> today to find out
                    more.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =================================================
                    ABOUT US
          ================================================= */}

      <section id="aboutus">
        <div className="aboutus">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="heading"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <h4>The best leased line is right here.</h4>
                </div>

                <div className="jabtout advantagestn">
                  <div
                    className="aboutimg"
                    data-aos="fade-left"
                    data-aos-offset="50"
                    data-aos-duration="600"
                    data-aos-once="true"
                    data-aos-easing="ease-in-sine"
                  >
                    <img src={Aboutus} alt="About Jujhar Group" />
                  </div>

                  <div className="jabcont">
                    <div
                      className="advantagestn"
                      data-aos="fade-right"
                      data-aos-offset="50"
                      data-aos-duration="600"
                      data-aos-once="true"
                      data-aos-easing="ease-in-sine"
                    >
                      <ul>
                        <li>
                          <h4>Superfast Speed</h4>
                          <p>
                            Get high speed of up to 1Gbps with full duplex i.e.
                            1:1 for both uploads and downloads - even during
                            peak hours.
                          </p>
                        </li>

                        <li>
                          <h4>Reliable Performance</h4>
                          <p>
                            Get the highly reliable enterprise leased line
                            service with higher uptime – no matter how many
                            other users are on the network.
                          </p>
                        </li>

                        <li>
                          <h4>Static IPs</h4>
                          <p>
                            Experience a stable business internet network and
                            easily access remote devices with a Static IP pool.
                          </p>
                        </li>

                        <li>
                          <h4>Dedicated Access</h4>
                          <p>
                            Enjoy fast & seamless connectivity with 24*7 backend
                            support.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =================================================
                    NETPLUS NUMBERS
          ================================================= */}

      <section id="netplusnumber">
        <div className="plans smarthome">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="title m-0"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <h3>Why Netplus Internet Leased Line?</h3>
                </div>

                <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
                  {({ isVisible }) => (
                    <div
                      className="count"
                      data-aos="fade-up"
                      data-aos-offset="50"
                      data-aos-duration="600"
                      data-aos-once="true"
                      data-aos-easing="ease-in-sine"
                    >
                      {/* 100000 KM */}

                      <div className="App">
                        <div className="countnum">
                          {isVisible ? (
                            <CountUp
                              start={state.turnover === 1 ? 1 : 100000}
                              end={100000}
                              duration={3}
                              onEnd={() =>
                                setState({
                                  ...state,
                                  turnover: 100000,
                                })
                              }
                            />
                          ) : (
                            <CountUp start={1} end={100000} duration={0} />
                          )}
                          +<p>Km</p>
                          <div className="labelcont">
                            <p>SOLID INFRASTRUCTURE OF FIBER NETWORK</p>
                          </div>
                        </div>
                      </div>

                      {/* 3000 CUSTOMERS */}

                      <div className="App">
                        <div className="countnum">
                          {isVisible ? (
                            <CountUp
                              start={state.workforce === 1 ? 1 : 3000}
                              end={3000}
                              duration={2}
                              onEnd={() =>
                                setState({
                                  ...state,
                                  workforce: 3000,
                                })
                              }
                            />
                          ) : (
                            <CountUp start={1} end={3000} duration={0} />
                          )}
                          +
                          <div className="labelcont">
                            <p>Premium Enterprise Customers</p>
                          </div>
                        </div>
                      </div>

                      {/* NOC */}

                      <div className="App">
                        <div className="countnum">
                          <p>NOC & DWDN</p>

                          <div className="labelcont">
                            <p>State-of-the-art secured network</p>
                          </div>
                        </div>
                      </div>

                      {/* WORKFORCE */}

                      <div className="App">
                        <div className="countnum">
                          {isVisible ? (
                            <CountUp
                              start={state.workforce === 1 ? 1 : 4500}
                              end={4500}
                              duration={2}
                              onEnd={() =>
                                setState({
                                  ...state,
                                  workforce: 4500,
                                })
                              }
                            />
                          ) : (
                            <CountUp start={1} end={4500} duration={0} />
                          )}
                          +
                          <div className="labelcont">
                            <p>Dedicated workforce</p>
                          </div>
                        </div>
                      </div>

                      {/* HOME PASSES */}

                      <div className="App">
                        <div className="countnum">
                          {isVisible ? (
                            <CountUp
                              start={state.cities === 1 ? 1 : 7}
                              end={7}
                              duration={3}
                              onEnd={() =>
                                setState({
                                  ...state,
                                  cities: 7,
                                })
                              }
                            />
                          ) : (
                            <CountUp start={1} end={7} duration={0} />
                          )}
                          <p>Lakh</p> +
                          <div className="labelcont">
                            <p>Home passes of FTTH</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </VisibilitySensor>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =================================================
                    PARTNERS
          ================================================= */}

      <section id="partner">
        <div className="partner">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div className="partnerstn">
                  {/* =================================================
                              OEM PARTNER
                      ================================================= */}

                  <div
                    className="partnerbox"
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-duration="600"
                    data-aos-once="true"
                    data-aos-easing="ease-in-sine"
                  >
                    <div className="heading">
                      <h4>OEM Partner</h4>
                    </div>

                    <ul>
                      <li>
                        <img src={Cisco} alt="Cisco" />
                      </li>

                      <li>
                        <img src={Nokia} alt="Nokia" />
                      </li>

                      {/* <li>
                        <img
                          src={Huawai}
                          alt="Huawai"
                        />
                      </li> */}

                      <li>
                        <img src={Genexis} alt="Genexis" />
                      </li>

                      {/* <li>
                        <img
                          src={Zte}
                          alt="ZTE"
                        />
                      </li> */}

                      <li>
                        <img src={Ericssion} alt="Ericssion" />
                      </li>

                      <li>
                        <img src={alphion} alt="alphion" />
                      </li>
                    </ul>
                  </div>

                  {/* =================================================
                              IT PARTNER
                      ================================================= */}

                  <div
                    className="partnerbox"
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-duration="600"
                    data-aos-once="true"
                    data-aos-easing="ease-in-sine"
                  >
                    <div className="heading">
                      <h4>IT Partner</h4>
                    </div>

                    <ul>
                      <li>
                        <img src={Sterlite} alt="Sterlite Tech" />
                      </li>

                      <li>
                        <img src={Oracle} alt="Oracle" />
                      </li>

                      <li>
                        <img src={Solarwinds} alt="Solarwinds" />
                      </li>

                      <li>
                        <img src={Elite} alt="Elite Core" />
                      </li>

                      <li>
                        <img src={H8} alt="Height 8" />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =================================================
                    FAQ
          ================================================= */}

      <section id="faq">
        <div className="faq">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="heading"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <h4>Frequently Asked Questions</h4>
                </div>

                <div
                  className="faqcont"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <Accordion atomic={true}>
                    <AccordionItem title="What is an internet leased line?">
                      <div className="accordiancont">
                        <p>
                          Unlike broadband, which works on a shared platform, a
                          leased line gives you a single line all to yourself.
                          Therefore, no busy periods or dips in data service to
                          worry about. It enables consistent, reliable & high
                          speed internet connectivity for your business.
                        </p>
                      </div>
                    </AccordionItem>

                    <AccordionItem title="What is the advantage of a leased line network?">
                      <div className="accordiancont">
                        <p>
                          A leased line network is a dedicated network solution
                          that provides reliable and uninterrupted internet
                          access for your business. These networks improve
                          business growth and productivity by offering
                          high-performance, agile, and secure connectivity that
                          you can rely on. Additionally, our leased line
                          solutions can be customized to your company's unique
                          needs.
                        </p>
                      </div>
                    </AccordionItem>

                    <AccordionItem title="How can I set up a dedicated leased line?">
                      <div className="accordiancont">
                        <p>
                          A dedicated business leased line is easy to deploy and
                          our network experts can help you create a business
                          internet solution that's tailor-made to your
                          organization.
                        </p>
                      </div>
                    </AccordionItem>

                    <AccordionItem title="Why is Netplus Internet leased line ideal for my business?">
                      <div className="accordiancont">
                        <p>
                          Netplus internet leased line is exclusively designed
                          to support the unique needs of a new age businesses.
                          The superior efficiency, reliability, and scalability
                          of our leased line solution enhances business agility
                          while also improving productivity by ensuring
                          uninterrupted and hassle-free connectivity.
                        </p>
                      </div>
                    </AccordionItem>

                    <AccordionItem title="What is the difference between broadband and leased line?">
                      <div className="accordiancont">
                        <p>
                          When you use a broadband connection, you share your
                          bandwidth with others. Whereas an internet leased line
                          is a dedicated line just for you. That means you don't
                          need to share it with anyone else. There are no risk
                          of lags when you're working transferring file on the
                          cloud.
                        </p>
                      </div>
                    </AccordionItem>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <Contactform /> */}

      <Footer />
    </>
  );
};
